import { Module, MutationTree, ActionTree } from 'vuex';
import { RootState, AuthenticationModuleState, User } from '@/types';
import UserService from '@/services/userService';
import LocalStorageService from '@/services/localStorageService';

const userService = new UserService();
const localStorageService = new LocalStorageService();

const state: AuthenticationModuleState = {
  localUser: null,
  error: null
};

export const actions: ActionTree<AuthenticationModuleState, RootState> = {
  checkLocalStorageForUser({ commit }) {
    const localUser: User | null = localStorageService.getLocalUser();
    if (localUser) {
      commit('authenticationSuccess', localUser);
    }
  },
  signUp({ commit }, { email, password, username }) {
    commit('clearError');
    return userService.signUserUp(email, password, username)
      .then((user: User) => {
        commit('authenticationSuccess', user);
      })
      .catch((reason: any) => {
        commit('authenticationFailure', reason);
        throw reason;
      });
  },
  logIn({ commit }, { email, password }) {
    commit('clearError');
    return userService.logUserIn(email, password)
      .then((user: User) => {
        commit('authenticationSuccess', user);
      })
      .catch((reason: any) => {
        commit('authenticationFailure', reason);
        throw reason;
      });
  },
  logOut({ commit }) {
    return userService.logUserOut()
      .then(() => {
        commit('authenticationSuccess', null);
      })
      .catch((reason: any) => {
        commit('authenticationFailure', reason);
        throw reason;
      });
  },
  clearError({ commit }) {
    commit('clearError');
  }
};

export const mutations: MutationTree<AuthenticationModuleState> = {
  authenticationSuccess(theState: AuthenticationModuleState, user: User) {
    theState.localUser = user;
    theState.error = null;
  },
  authenticationFailure(theState: AuthenticationModuleState, error: string) {
    theState.error = error;
  },
  clearError(theState: AuthenticationModuleState) {
    theState.error = null;
  }
};

export const authenticationModule: Module<AuthenticationModuleState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations
};
